import React, { useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { cndWrapperURL } from "../utils/api-url-list";

const Appointments = () => {
  const { state } = useLocation();

  useEffect(() => {
    const controller = new AbortController();
    window.addEventListener(
      "message",
      (e) => {
        if (typeof window.ReactNativeWebView?.postMessage === "function") {
          window.ReactNativeWebView.postMessage(e.data);
        } else {
          try {
            const { type, data } = JSON.parse(e.data);
            switch (type) {
              case "download":
                const downloadAnchorNode = document.createElement("a");
                const dataURI = `data:${data.mimeType};base64,${data.b64data}`;
                downloadAnchorNode.setAttribute("href", dataURI);
                downloadAnchorNode.setAttribute("download", data.filename);
                document.body.appendChild(downloadAnchorNode);
                downloadAnchorNode.click();
                downloadAnchorNode.remove();
                break;
              default:
                console.log("Message Recieved", type, data);
                break;
            }
          } catch (e) {
            console.error(e);
          }
        }
      },
      { signal: controller.signal }
    );
    return () => {
      controller.abort();
    };
  }, []);

  return (
    <div className="">
      <div className="flex items-center mb-5 px-6 ">
        <Link to={-1} className="mr-3">
          <svg
            width="6"
            height="10"
            viewBox="0 0 10 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.42402 16.2142C9.99277 15.6454 9.99277 14.7267 9.42402 14.1579L3.76569 8.49959L9.42402 2.84126C9.99277 2.27251 9.99277 1.35376 9.42402 0.785009C8.85527 0.216259 7.93652 0.216259 7.36777 0.785009L0.674024 7.47876C0.105274 8.04751 0.105274 8.96626 0.674024 9.53501L7.36777 16.2288C7.92194 16.7829 8.85527 16.7829 9.42402 16.2142Z"
              fill="#fff"
            />
          </svg>
        </Link>
        <h3 className="text-white text-[14px] font-semibold">
          Back to My Cayrteam
        </h3>
      </div>
      <div
        className="iframe-container"
        style={{
          position: "relative",
          width: "100%",
          height: "100%",
          overflow: "hidden",
        }}
      >
        <iframe
          src={cndWrapperURL(
            `/patient/pendingRedirect?${new URLSearchParams(state).toString()}`
          )}
          sandbox="allow-same-origin allow-scripts allow-forms allow-downloads allow-popups"
          allow="autoplay; fullscreen; camera; microphone; geolocation; display-capture"
          title="Pending Appointments"
          width="100%"
          height="100%"
          style={{
            border: "none",
            overflow: "hidden",
            minHeight: "100vh",
            backgroundColor: "#02102B",
          }}
        />
      </div>
    </div>
  );
};

export default Appointments;
